export const PPH_23_EXAMPLES = [
  {
    titleKey: "taxCalculator.pph23.examples.case1.title",
    objectTypeKey: "taxCalculator.pph23.examples.case1.objectType",
    descriptionKey: "taxCalculator.pph23.examples.case1.description",
    autoFillData: {
      objectCode: "24-103-01",
      grossAmount: 50000000,
      hasNPWP: true,
    },
  },
  {
    titleKey: "taxCalculator.pph23.examples.case2.title",
    objectTypeKey: "taxCalculator.pph23.examples.case2.objectType",
    descriptionKey: "taxCalculator.pph23.examples.case2.description",
    autoFillData: {
      objectCode: "24-102-01",
      grossAmount: 30000000,
      hasNPWP: false,
    },
  },
  {
    titleKey: "taxCalculator.pph23.examples.case3.title",
    objectTypeKey: "taxCalculator.pph23.examples.case3.objectType",
    descriptionKey: "taxCalculator.pph23.examples.case3.description",
    autoFillData: {
      objectCode: "24-104-08",
      grossAmount: 100000000,
      hasNPWP: true,
    },
  },
  {
    titleKey: "taxCalculator.pph23.examples.case4.title",
    objectTypeKey: "taxCalculator.pph23.examples.case4.objectType",
    descriptionKey: "taxCalculator.pph23.examples.case4.description",
    autoFillData: {
      objectCode: "24-100-02",
      grossAmount: 25000000,
      hasNPWP: false,
    },
  },
];
